import { ImageScaleView, View } from '@play-co/timestep-core/ui';
import i18n from 'src/lib/i18n/i18n';
import { Feature } from 'src/replicant/analytics';
import PopupMatch2Base, {
  PopupMatch2BaseInitOptions,
} from '../../components/PopupMatch2Base';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import StateObserver, { user } from 'src/StateObserver';
import { Match2Timer } from '../../components/Match2Timer';
import { getCurrentTeamEventEndDate } from 'src/replicant/team/team.getters';
import ButtonScaleView from 'src/lib/ui/components/ButtonScaleView';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';

export default class PopupTeamCompetitionIntro extends PopupMatch2Base {
  constructor(opts: { superview: View; close: (cta?: boolean) => void }) {
    super({
      superview: opts.superview,
      panelImageOpts: {
        image: 'assets/ui/match2/common/panel_intro.png',
        width: 588,
        height: 700,
      },
      zIndex: 10000,
      offsetY: -140,
      title: {
        type: 'image',
        opts: {
          scaleMethod: 'contain',
          canHandleEvents: false,
          image: `assets/ui/match2/team/competition/comp_title_${StateObserver.getLocale()}.png`,
          width: 450,
          height: 150,
          y: -10,
        },
      },
      cta: {
        localeText: () => i18n('match2.ui.play').toLocaleUpperCase(),
        onClick: () => opts.close(true),
        positioning: 'edge',
      },
      close: () => opts.close(false),
      tracking: {
        feature: Feature.MATCH2.TEAM._,
        $subFeature: Feature.MATCH2.TEAM.COMPETITION.INTRO_POPUP,
      },
    });

    new LangBitmapFontTextView({
      superview: this.panel,
      x: this.panel.style.width * 0.5,
      y: this.panel.style.height - 145,
      align: 'center',
      verticalAlign: 'center',
      centerOnOrigin: true,
      size: 30,
      font: 'Body',
      width: this.panel.style.width * 0.85,
      height: 100,
      color: '#BF8147',
      wordWrap: true,
      localeText: () => i18n(`match2.team.competition_intro`),
    });
    new ImageScaleView({
      superview: this.panel,
      image: `assets/ui/match2/team/competition/comp_intro_hero.png`,
      width: 500,
      height: 500,
      x: this.panel.style.width * 0.5 - 1,
      y: 278,
      scaleMethod: 'contain',
      centerOnOrigin: true,
    });

    const timer = new Match2Timer({
      superview: this.panel,
      x: this.panel.style.width * 0.5,
      y: 90,
      centerOnOrigin: true,
    });
    timer.setRemainingTimeGetter(
      (now) => (getCurrentTeamEventEndDate(now) ?? 0) - now,
    );
    timer.autoUpdate();

    new ButtonScaleView({
      superview: this.panel,
      centerOnOrigin: true,
      image: 'assets/ui/match2/team/competition/btn_info.png',
      width: 56,
      height: 63,
      tracking: {
        feature: Feature.MATCH2.TEAM.COMPETITION._,
        $subFeature: Feature.MATCH2.TEAM.COMPETITION.INFO_BUTTON,
      },
      onClick: () => openPopupPromise('popupTeamCompetitionInfo', {}),
    });
  }

  public init(opts: PopupMatch2BaseInitOptions): void {
    super.init(opts);
    if (user().team.currentTeamId) return;
    this.buttonCta!.label.localeText = () =>
      i18n('match2.team.join').toUpperCase();
  }
}
